import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flag',
})
export class FlagPipe implements PipeTransform {
  transform(value: string): string {
    if(value != null) return value.toLowerCase() + '.svg';
  }
}
